import { Glow, SectionHeader } from './primitives';

const NORMS = [
  'Основания отсрочки перечислены в ст. 24 ФЗ «О воинской обязанности и военной службе».',
  'Решение призывной комиссии должно быть мотивировано и вручено под подпись.',
  'Срок обжалования — 3 месяца с момента, когда вы узнали о нарушении права.',
];

export function ExpertiseSection() {
  return (
    <section className="px-4 py-14 md:px-8 md:py-20 xl:px-20">
      <div className="relative mx-auto max-w-[1280px] overflow-hidden rounded-4xl bg-ink-gradient p-7 md:p-14">
        <Glow color="gold" size={460} opacity={0.24} blur={70} className="-right-24 -top-24" />
        <Glow color="blue" size={420} opacity={0.2} blur={70} className="-bottom-24 -left-24" />

        <div className="relative z-10 flex flex-col gap-9">
          <SectionHeader
            tone="dark"
            eyebrow="Экспертиза"
            title="Мы находим то, что пропущено в документах"
            subtitle="Сопоставляем документы с нормами права и показываем, где именно возникают риски для вашей ситуации."
          />

          <div className="grid gap-6 lg:grid-cols-2">
            <div className="flex flex-col gap-5 rounded-3xl bg-white p-7 md:p-8">
              <span className="text-[12px] font-semibold uppercase tracking-[0.08em] text-muted">
                Документ
              </span>
              <div className="flex flex-col gap-4 rounded-2xl bg-soft p-6">
                <div className="flex flex-col gap-1.5">
                  <span className="text-[13px] text-muted">ФИО</span>
                  <span className="text-[17px] font-medium text-ink">Смирнов А. В.</span>
                </div>
                <div className="flex flex-col gap-1.5">
                  <span className="text-[13px] text-muted">Основание отсрочки</span>
                  <span className="inline-flex w-fit items-center rounded-lg border-[1.5px] border-dashed border-danger bg-danger-soft px-3 py-2 text-[17px] font-semibold text-danger">
                    не указано
                  </span>
                </div>
                <div className="flex flex-col gap-1.5">
                  <span className="text-[13px] text-muted">Статья</span>
                  <span className="text-[17px] font-semibold text-ink">24</span>
                </div>
              </div>
              <div className="flex items-center gap-2 text-[14px] font-medium text-danger">
                <span className="h-2 w-2 rounded-full bg-danger" />
                Расхождение с приписным свидетельством
              </div>
            </div>

            <div className="flex flex-col gap-5 rounded-3xl border border-panel-border bg-panel p-7 md:p-8">
              <span className="text-[12px] font-semibold uppercase tracking-[0.08em] text-gold">
                Норма права
              </span>
              <ol className="flex flex-col gap-5">
                {NORMS.map((norm, index) => (
                  <li key={norm} className="flex items-start gap-3.5">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-gradient text-[13px] font-bold text-white">
                      {index + 1}
                    </span>
                    <span className="text-[16px] leading-[1.5] text-white md:text-[18px] md:leading-[27px]">
                      {norm}
                    </span>
                  </li>
                ))}
              </ol>
              <p className="mt-auto text-[13px] leading-[1.4] text-muted-sky">
                Мы сверяем каждый пункт и готовим позицию защиты.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
